"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var smartimagesrc_1 = require("@ezbuy/smartimagesrc");
var Image_1 = require("../../../components/Image");
var isomorphismConstant_1 = require("../../../../utils/isomorphismConstant");
var string_1 = require("../../../../utils/string");
var link_1 = require("../../../utils/link");
var css_1 = require("../../../utils/css");
var styles = require("./index.scss");
var RollOver = (function (_super) {
    __extends(RollOver, _super);
    function RollOver() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getLink = function (item) {
            if (item.ig && item.ig.igroup && item.ig.igroup[isomorphismConstant_1.default.language]) {
                return item.ig.igroup[isomorphismConstant_1.default.language].img;
            }
            else {
                return item.img;
            }
        };
        return _this;
    }
    RollOver.prototype.render = function () {
        var _this = this;
        var _a = this.props, _b = _a.cardBanners, cardBanners = _b === void 0 ? [] : _b, viewMore = _a.viewMore, id = _a.id;
        var oneItem = cardBanners[0] && cardBanners[0].items && cardBanners[0].items[0];
        var height = css_1.formatBannerSize({
            width: oneItem && oneItem.width,
            height: oneItem && oneItem.height
        }).height;
        return (React.createElement("div", { className: styles.rollOverContainer, id: id, style: { height: oneItem && oneItem.width ? "calc(" + height + " * 0.36)" : height } },
            cardBanners.map(function (item, index) { return (React.createElement("a", { href: string_1.isEmpty(item.items[0].link) ? undefined : item.items[0].link },
                React.createElement(Image_1.default, { className: styles.img, src: smartimagesrc_1.makeImageUrls(_this.getLink(item.items[0]), {
                        online: true,
                        qnParams: {
                            w: 135
                        },
                        aliSize: 2
                    })[0], key: index, useOriginSrc: true, params: "imageView2/2/w/135", alisize: 2, isLazyLoad: false }))); }),
            viewMore && (React.createElement("div", { className: styles.viewMore, onClick: function () { return link_1.clickJump(viewMore); } },
                React.createElement("div", { className: styles.icon }),
                React.createElement("div", { className: styles.text }, "View More")))));
    };
    return RollOver;
}(React.Component));
exports.default = RollOver;
